<template>
  <div class="header_component">
    <div class="header_info">
    <!-- 登录的公共组件内容 -->
    <div class="logo">
      <img src="../loginNewImg/logo.png" alt="">
    </div>
    <div class="inner">
      <div class="inner-span" v-for="item in typeList" :class="[chose == item.id ? 'chose' : '']" @click="goNextTypeListOrContent(item)">
        <div class="cursor">
          <span> {{ item.name }} </span>
        </div>
      </div>
    </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'loginAndOtherComponent',
  data() {
    return {
      typeList: [
        {
          id: '0',
          name: '首页',
          number: '1',
          sort: 1,
        },
        {
          id: '1',
          name: '服务特色',
          number: '1',
          sort: 1,
        }, {
          id: '2',
          name: '学习引擎',
          number: '2',
          sort: 1,
        },
        // {
        //   'id': '3',
        //   'name': '学习工具',
        //   'number': '3',
        //   'sort': 1
        // },
        {
          id: '6',
          name: '学员案例',
          number: '6',
          sort: 1,
        }, {
          id: '5',
          name: '帮助',
          number: '5',
          sort: 1,
        }],
      chose: undefined,
    };
  },
  watch: {
    '$route.query': {
      handler(value) {
        this.chose = value.id || '0';
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    goNextTypeListOrContent(item) {
      if (item.id != this.chose) {
        if (Number(item.id)) {
          this.$router.push({ path: '/introduction', query: { id: item.id, name: item.name } });
        } else {
          this.$router.push({ path: '/login' });
        }
      }
    },
  },
};
</script>

<style scoped lang="stylus">
.header_component {
  width: 100%
  height: 73px
  overflow hidden
}

.logo {
  width: 186px
  height: 37px
  float left
  padding 19px 0 17px 16px

  img {
    width: 100%
    height: 100%
    display block
  }
}

.inner {
  padding-top 28px
  float right
  .inner-span {
    float left
    font-size: 16px;
    font-family: SegoeUI-SemiBold, SegoeUI;
    font-weight: 600;
    color: #333333;
    padding-left 58px
    height: 45px
    position relative
    &.chose {
      color #E60020
      div{
        position relative
        height: 100%
        &:after {
          content: " "
          display:block
          width: 160%;
          height: 4px;
          background: #E60020;
          position absolute
          left -32%
          bottom 0
        }
      }
    }
  }
}
</style>
